import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { CancelledIcon } from 'images'

/**
 * Error message.
 * @Tags( shared, presentational )
 */
const ErrorMessage = ({ children, danger, classNames = undefined, variant = 'primary', style = undefined }) => {
  if (variant === 'primary') {
    return (
      <div
        className={classnames({
          'error-message alert': true,
          [`alert-${danger ? 'danger' : 'warning'}`]: true,
          [classNames]: true,
        })}
      >
        {typeof children === 'string' ? <p>{children}</p> : children}
      </div>
    )
  } else if (variant === 'light') {
    return (
      <div
        className={classnames({
          'error-message-light': true,
          [classNames]: true,
        })}
        style={style}
      >
        <div className="icon">
          <CancelledIcon width={8} height={8} />
        </div>

        <p className="text">{children}</p>
      </div>
    )
  }

}

ErrorMessage.propTypes = {
  /**
   * HTML lub string content
   */
  children: PropTypes.node.isRequired,
  danger: PropTypes.bool,
  classNames: PropTypes.string,
}

export default ErrorMessage
